import React from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { InputText } from "primereact/inputtext";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import ContactImage from "../image/Contact_us.jpg"; // Ensure correct path
import "./ContactUs.css";
import { InputTextarea } from "primereact/inputtextarea";

function ContactUs() {
  return (
    <div className="contactus-container">
      {/* Header Section */}
      <div className="contact-header">
        {/* Background Decorative Elements */}
        <div className="decorative-elements">
          <div className="square"></div>
          <div className="circle"></div>
        </div>

        <div className="contact-header-content">
          <h1>Get in Touch</h1>
          <p>
            Have questions or need assistance? We’re here to help! Whether you
            have inquiries about our services, partnership opportunities, or
            just want to say hello, we’d love to hear from you.
          </p>

          <p>
            You can also connect with us on social media for the latest updates
            and news.
          </p>
        </div>

        <div className="contact-header-image">
          <img src={ContactImage} alt="Customer Support" />
        </div>
      </div>

      {/* Contact Cards Section */}
      <div className="contact-cards">
        {/* Talk to Sales */}
        <Card className="contact-card animate">
          <div className="contact-icon">
            <FaPhoneAlt size={28} />
          </div>
          <h3>Talk to Sales or reach to us on our Location</h3>
          <p>
            Interested in our services? Just pick up the phone to chat with a
            member of our sales team.
          </p>
          <p className="contact-link">+91 9941332698</p>

          {/* Google Maps Panel */}
          <div className="google-map">
            <h4>Tarushi Healthcare</h4>
            <iframe
              title="Tarushi Healthcare Location"
              src="https://maps.google.com/maps?q=17.4483,78.3915&hl=en&z=15&output=embed"
              width="100%"
              height="250"
              style={{ border: 0, borderRadius: "10px" }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>

            {/* Direct Google Maps Link */}
            <p>
              <a
                href="https://www.google.com/maps?q=17.4483,78.3915"
                target="_blank"
                rel="noopener noreferrer"
              >
                View on Google Maps
              </a>
            </p>
          </div>
        </Card>

        {/* Contact Us via Email */}
        <Card className="contact-card animate">
          <div className="contact-icon">
            <MdEmail size={28} />
          </div>
          <h3>Contact Us via Email</h3>
          <p>
            Send us your queries, and we'll get back to you as soon as possible.
          </p>

          <div className="contact-form">
            <div className="p-inputgroup">
              <InputText placeholder="First Name" className="contact-input" />
              <InputText placeholder="Last Name" className="contact-input" />
            </div>

            <InputText
              placeholder="Email"
              className="contact-input full-width"
            />
            <InputText
              placeholder="Phone"
              className="contact-input full-width"
            />
            <InputTextarea
              placeholder="Message"
              className="contact-textarea"
              autoResize
            />

            <Button className="contact-button submit-btn">Submit</Button>
          </div>
        </Card>
      </div>

      <Divider />
    </div>
  );
}

export default ContactUs;
